import type { IconSvgObject } from './types';

const ArrowLeftBigIcon: IconSvgObject = [
  ["path", { d: "M3.8664 12.8402L10.2934 18.8081C10.4262 18.9315 10.6007 19 10.782 19C11.1785 19 11.5 18.6785 11.5 18.282V15H19.5C20.0523 15 20.5 14.5523 20.5 14V10C20.5 9.44772 20.0523 9 19.5 9L11.5 9L11.5 5.71803C11.5 5.32147 11.1785 5 10.782 5C10.6007 5 10.4262 5.06854 10.2934 5.19186L3.8664 11.1598C3.63276 11.3767 3.5 11.6812 3.5 12C3.5 12.3188 3.63276 12.6233 3.8664 12.8402Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ArrowLeftBigIcon;
